import { WalletController, SettingsController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { TransferPinConfirm } from '../../pages';
import { useStores } from '../../stores';
import constant from '../../utils/constant';
import React, { useState } from 'react';

const TransferPinConfirmationContainer = ({ transferSwitchState }) => {
	const { walletStore } = useStores();
	const payload = walletStore.transferPayload;
	const data = {
		amount: payload.transactionAmount,
		accountName: payload.accountName || 'test',
	};
	const [loading, setLoading] = useState(false);
	const onSubmit = async pin => {
		payload.pin = pin;
		setLoading(true);
		delete payload.accountName;
		payload.currencyCode = 'NGN';
		const response = await WalletController.transferFund(payload);
		const { status, errorMessage } = response;
		SettingsController.runTransactionSetup();
		setLoading(false);
		if (status === constant.Success) {
			return transferSwitchState.goToTransferSuccess();
		}

		if (errorMessage) {
			return MimaToastUtil.error({ message: errorMessage });
		}
		return transferSwitchState.goToTransferFailed();
	};

	return (
		<TransferPinConfirm
			key="transferFundOptionModal"
			onSubmit={onSubmit}
			payload={data}
			loading={loading}
		/>
	);
};

export default TransferPinConfirmationContainer;
